import * as constants from '../utils/constants';

// export const canvasInitState = {
//   'DIG009-NA-NA': {
//     Canvas: {
//       Bleed: 0.125,
//       Constant: {
//         BigResOverScreenRes: 1,
//         bleedSize: 9,
//         DesignCenter: 243,
//         DesignHeight: 450,
//         DesignWidth: 522,
//         FoldLeft: 238,
//         FoldRight: 247,
//         FoldWidth: 9,
//         FullHeight: 450,
//         fullWidth: 522,
//         IsCalendar: true,
//         marginSize: 9,
//         MaxHeight: 414,
//         MaxWidth: 234,
//         Scale: 1,
//         ScreenResOverBigRes: 1,
//         ScreenResOverLrgRes: 0.75,
//         SideWidth: 238,
//         TextDesignHeight: 414,
//         TextDesignWidth: 486,
//         TextInset: 18
//       },
//       DefaultFontSize: 11,
//       FoldWidth: 0.125,
//       Height: 6.25,
//       ID: 3,
//       IsCalendar: false,
//       ItemStyle: 'comp_7x6calendar',
//       ItemType: 1,
//       Margin: 0.125,
//       MultilineHeight: 80,
//       MultilineWidth: 100,
//       NewTextType: 0,
//       PreviewResolution: 72,
//       ProductionResolution: 96,
//       ThumbnailResolution: 72,
//       Width: 7.25
//     },
//     //BackgroundImageUrl: "https://demo.silcn.co/api/v1/entity/Promo/content/digital_design_16_2757/image?&wid=522&hei=450",
//     BackgroundImageUrl: 'images/canvas_back1.png',
//     HasIlluminatedLaserSwitch: false,
//     IsIllumniatedLaserSwitchOn: false,
//     IsOnlyBlankBackgroundOffered: false,
//     LocationThumbnailPath: 'url(/resources/icons/imprint/location/NA_NA.jpg)',
//     OrderSummary2ClientId: 'ctl00_ctl00_cpBody_cpBody_orderSummary2',
//     ShowHorisontalRuler: false,
//     ShowVerticalRuler: false,
//     StudioItemType: 1,
//     TemplateId: 8279,
//     TemplateType: 2
//   },

//   'DIG010-NA-NA': {
//     Canvas: {
//       Bleed: 0.125,
//       Constant: {
//         BigResOverScreenRes: 1,
//         bleedSize: 9,
//         DesignCenter: 243,
//         DesignHeight: 450,
//         DesignWidth: 522,
//         FoldLeft: 238,
//         FoldRight: 247,
//         FoldWidth: 9,
//         FullHeight: 450,
//         fullWidth: 522,
//         IsCalendar: true,
//         marginSize: 9,
//         MaxHeight: 414,
//         MaxWidth: 234,
//         Scale: 1,
//         ScreenResOverBigRes: 1,
//         ScreenResOverLrgRes: 0.75,
//         SideWidth: 238,
//         TextDesignHeight: 414,
//         TextDesignWidth: 486,
//         TextInset: 18
//       },
//       DefaultFontSize: 11,
//       FoldWidth: 0.125,
//       Height: 6.25,
//       ID: 3,
//       IsCalendar: false,
//       ItemStyle: '',
//       ItemType: 1,
//       Margin: 0.125,
//       MultilineHeight: 80,
//       MultilineWidth: 100,
//       NewTextType: 0,
//       PreviewResolution: 72,
//       ProductionResolution: 96,
//       ThumbnailResolution: 72,
//       Width: 7.25
//     },
//     //BackgroundImageUrl: "https://demo.silcn.co/api/v1/entity/Promo/content/digital_design_16_2757/image?&wid=522&hei=450",
//     BackgroundImageUrl: 'images/apl.png',
//     HasIlluminatedLaserSwitch: false,
//     IsIllumniatedLaserSwitchOn: false,
//     IsOnlyBlankBackgroundOffered: false,
//     LocationThumbnailPath: 'url(/resources/icons/imprint/location/NA_NA.jpg)',
//     OrderSummary2ClientId: 'ctl00_ctl00_cpBody_cpBody_orderSummary2',
//     ShowHorisontalRuler: false,
//     ShowVerticalRuler: false,
//     StudioItemType: 1,
//     TemplateId: 8279,
//     TemplateType: 2
//   }
// };
export const sampleStockArt = {
  width: 100,
  height: 100,
  description: 'Paper & Quill Pen',
  fileName: '/stock_art/00397',
  scene7FileName: 'PromotionalStore/stockart_00397',
  type: 1,
  url: 'http://images.promotionalstore.com/is/image/PromotionalStore/i?src=is{PromotionalStore/stockart_00397}&$Studio_StockT$',
  guid: '8ca16e15-e60d-4124-984e-c249aebf2702',
  stockId: '00397',
};

export const initImageList = {
  'DIG009-NA-NA': [
    {
      autoCropRect: {
        x: 0,
        y: 1,
        width: 129,
        height: 133,
        isEmpty: false,
      },
      cropRect: {
        x: 0,
        y: 0,
        width: 129,
        height: 133,
        isEmpty: false,
      },
      finalCropRect: {
        x: 0,
        y: 1,
        width: 129,
        height: 133,
        isEmpty: false,
      },
      logoSource: 0,
      originFileName: null,
      removeWhiteOption: 0,
      pngFileNameList: [
        '/Customer/Amsterdam/logos/a/0/2/b/b/7/a/6/0/-/9/b/e/3/-/4/e/1/f/-/a/c/2/7/-/b/c/7/1/b/d/d/4/4/5/7/c/a02bb7a60-9be3-4e1f-ac27-bc71bdd4457c',
        null,
        null,
      ],
      pngFileName:
        '/Customer/Amsterdam/logos/a/0/2/b/b/7/a/6/0/-/9/b/e/3/-/4/e/1/f/-/a/c/2/7/-/b/c/7/1/b/d/d/4/4/5/7/c/a02bb7a60-9be3-4e1f-ac27-bc71bdd4457c',
      pngFileNameOfNoRemoveWhite:
        '/Customer/Amsterdam/logos/a/0/2/b/b/7/a/6/0/-/9/b/e/3/-/4/e/1/f/-/a/c/2/7/-/b/c/7/1/b/d/d/4/4/5/7/c/a02bb7a60-9be3-4e1f-ac27-bc71bdd4457c',
      cloudResourceIdList: [null, null, null],
      cloudResourceId: null,
      imagingServiceSessionIdList: [null, null, null],
      imagingServiceSessionId: null,
      colors: [],
      originalWidth: 131,
      originalHeight: 135,
      horizonAlign: null,
      customElement: false,
      direction: 0,
      height: 80,
      itemElementId: 0,
      onBack: 0,
      width: 77,
      x: 427,
      y: 352,
      zIndex: 1,
      description: '644363.png',
      fileName: '/Customer/Amsterdam/logos/6/4/4/3/6/3/644363.png',
      scene7FileName: 'a02bb7a60-9be3-4e1f-ac27-bc71bdd4457c',
      type: 0,
    },
  ],
};

export const imageInitState = {
  'DIG009-NA-NA': [
    {
      data: {
        autoCropRect: {
          x: 0,
          y: 1,
          width: 129,
          height: 133,
        },
        cropRect: {
          x: 0,
          y: 0,
          width: 129,
          height: 133,
        },
        finalCropRect: {
          x: 0,
          y: 1,
          width: 129,
          height: 133,
        },
        height: 133,
        //id: '74617c65-6601-428d-8bb5-035c932e712b',
        imagingServiceSessionIdCache: ['5d0153fe-9141-4939-883a-bba35e8f025a', null, null],
        logoSource: 0,
        nucleusId: null,
        nucleusIdCache: [null, null, null],
        originFileName: 'APL.png',
        pngFileName: '/logos/6/4/1/2/3/1/641231.png',
        pngFileNameList: ['/logos/6/4/1/2/3/1/641231.png', null, null],
        removeWhiteOption: 0,
        scene7FileNameCache: [null, null, null],
        width: 129,
        color: null,
        customElement: false,
        direction: 90,
        itemElementId: 0,
        onBack: 0,
        originalWidth: 131,
        originalHeight: 135,
        x: 180,
        y: 40,
        zIndex: 1,
        description: '',
        fileName: '6/4/1/2/3/0/641230.png',
        scene7FileName: '',
        type: 0,
        url: 'api/v1/uploadlogo?fileName=/logos/6/4/1/2/3/1/641231.png',
      },
      ui: {
        guid: '74617c65-6601-428d-8bb5-035c932e712b',
        status: constants.elementStatus.Unselected,
      },
    },
    {
      data: {
        autoCropRect: {
          x: 0,
          y: 1,
          width: 129,
          height: 133,
        },
        cropRect: {
          x: 0,
          y: 65,
          width: 129,
          height: 68,
        },
        finalCropRect: {
          x: 0,
          y: 66,
          width: 129,
          height: 68,
        },
        height: 68,
        //id: 'dfgf456-9784-fd34-6hfe-84gfdfgtf',
        imagingServiceSessionIdCache: ['5d0153fe-9141-4939-883a-bba35e8f025a', null, null],
        logoSource: 0,
        nucleusId: null,
        nucleusIdCache: [null, null, null],
        originFileName: 'APL.png',
        pngFileName: '/logos/6/4/1/2/3/1/641231.png',
        pngFileNameList: ['/logos/6/4/1/2/3/1/641231.png', null, null],
        removeWhiteOption: 0,
        scene7FileNameCache: [null, null, null],
        width: 129,
        color: null,
        customElement: false,
        direction: 90,
        itemElementId: 0,
        onBack: 0,
        originalWidth: 131,
        originalHeight: 135,
        x: 100,
        y: 200,
        zIndex: 2,
        description: '',
        fileName: '6/4/1/2/3/0/641230.png',
        scene7FileName: '',
        type: 0,
        url: 'api/v1/uploadlogo?fileName=/logos/6/4/1/2/3/1/641231.png',
      },
      ui: {
        guid: 'dfgf456-9784-fd34-6hfe-84gfdfgtf',
        status: constants.elementStatus.Unselected,
      },
    },
    {
      data: {
        autoCropRect: {
          x: 0,
          y: 0,
          width: 149,
          height: 27,
          isEmpty: true,
        },
        cropRect: {
          x: 0,
          y: 0,
          width: 149,
          height: 27,
          isEmpty: true,
        },
        finalCropRect: {
          x: 0,
          y: 0,
          width: 149,
          height: 27,
          isEmpty: false,
        },
        imagingServiceSessionIdCache: ['1f21b263-5267-4df9-84a7-eea1aec319e7', null, null],
        logoSource: 0,
        nucleusId: null,
        nucleusIdCache: [null, null, null],
        originalWidth: 149,
        originalHeight: 27,
        originFileName: 'VeryLong.png',
        pngFileName: '/logos/6/4/2/4/0/4/642404.png',
        pngFileNameList: ['/logos/6/4/2/4/0/4/642404.png', null, null],
        removeWhiteOption: 0,
        scene7FileNameCache: [null, null, null],
        color: null,
        customElement: false,
        direction: 0,
        height: 50,
        itemElementId: 0,
        onBack: 0,
        width: 278,
        x: 110,
        y: 300,
        zIndex: 3,
        description: '',
        fileName: '6/4/2/4/0/3/642403.png',
        scene7FileName: '',
        type: 0,
        url: 'api/v1/uploadlogo?fileName=/logos/6/4/2/4/0/4/642404.png',
      },
      ui: {
        guid: 'dff19057-7385-4186-b740-1ec1d7f88cfc',
        status: constants.elementStatus.Unselected,
      },
    },
    {
      data: {
        autoCropRect: {
          x: 107,
          y: 33,
          width: 126,
          height: 157,
          isEmpty: false,
        },
        cropRect: {
          x: 0,
          y: 0,
          width: 126,
          height: 157,
          isEmpty: true,
        },
        finalCropRect: {
          x: 107,
          y: 33,
          width: 126,
          height: 157,
          isEmpty: false,
        },
        imagingServiceSessionIdCache: ['c9dc8ea9-486c-4fd4-a2bb-6b3e8825122b', null, null],
        logoSource: 0,
        nucleusId: null,
        nucleusIdCache: [null, null, null],
        originalWidth: 320,
        originalHeight: 240,
        originFileName: 'test2-2.png',
        pngFileName: '/logos/6/4/2/4/8/2/642482.png',
        pngFileNameList: ['/logos/6/4/2/4/8/2/642482.png', null, null],
        removeWhiteOption: 0,
        scene7FileNameCache: [null, null, null],
        color: null,
        customElement: false,
        direction: 90,
        height: 297,
        itemElementId: 0,
        onBack: 0,
        width: 238,
        x: 500,
        y: 50,
        zIndex: 4,
        description: '',
        fileName: '6/4/2/4/8/1/642481.png',
        scene7FileName: '',
        type: 0,
        url: 'api/v1/uploadlogo?fileName=/logos/6/4/2/4/8/2/642482.png',
      },
      ui: {
        guid: 'd58c9266-3765-4ab2-93f9-1a03c088b153',
        status: constants.elementStatus.SingleSelected,
      },
    },
  ],
};

export const textInitState = {
  'DIG009-NA-NA': [
    {
      data: {
        x: 80,
        y: 80,
        itemElementId: -1,
        fontFace: 'Arial',
        color: '0 0 0 100',
        colorId: 0,
        colorReference: '000000',
        colorType: 0,
        direction: 0,
        text: 'dsfst',
        fontSize: 36,
        bold: false,
        italic: false,
        underline: false,
        horizonAlign: 0,
        horizonMultiAlign: 0,
        textMode: 1,
        width: 77,
        height: 37,
        onBack: 1,
        customElement: true,
      },
      ui: {
        guid: '2ff328bb-8e2e-4ddc-8e68-cec6674642f9',
        status: constants.elementStatus.Unselected,
        maxWidth: 153,
        maxHeight: 73,
        minWidth: 77,
        minHeight: 37,
        fontFileName: 'Arial.ttf',
        fontImgFileName: 'Arial',
        maxFontSize: 72,
        visible: true,
        base64Image:
          'data:image/png;base64,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',
      },
    },
    {
      data: {
        x: 380,
        y: 280,
        itemElementId: -1,
        fontFace: 'Arial',
        color: '0 0 0 100',
        colorId: 0,
        colorReference: '000000',
        colorType: 0,
        direction: 90,
        text: 'dsfst',
        fontSize: 36,
        bold: false,
        italic: false,
        underline: false,
        horizonAlign: 0,
        horizonMultiAlign: 0,
        textMode: 1,
        width: 77,
        height: 37,
        onBack: 1,
        customElement: true,
      },
      ui: {
        guid: '67dd34-f4h7-gre6-9kd3-kgwedt75443',
        status: constants.elementStatus.Unselected,
        maxWidth: 153,
        maxHeight: 73,
        minWidth: 77,
        minHeight: 37,
        fontFileName: 'Arial.ttf',
        fontImgFileName: 'Arial',
        maxFontSize: 72,
        visible: true,
        base64Image:
          'data:image/png;base64,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',
      },
    },
  ],
};
